import React from 'react';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';
import preview from './blotterPreview.png';

export const blotterDescription: DropdownTooltipText = {
    body: (
        <>
            <div>
                The Order Blotter is a table listing all active and recent
                orders which can be configured to show columns such as: side,
                order quantity, traded quantity, order status, and more.
            </div>
            <div>
                Use the Order Blotter to select individual symbols for single
                stock widgets or filter the basket selection for portfolio
                widgets.
            </div>
        </>
    ),
    previews: [{ src: preview, altText: 'order-blotter-preview' }],
};
